module.exports = __webpack_public_path__ + "static/img/5.75487fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/5.jpg
// module id = +rX8
// module chunks = 16